import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 管理员
export default {
  
  getUserProductSum(params) { // 获取个人产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getUserProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getcompanySetUserProductSum(params) { // 获取企业分配给个人产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getcompanySetUserProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getUserDueProductSum(params) { //获取个人过期产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getUserDueProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getUserDueInMonthProductSum(params) { //获取个人即将过期（30天）产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getUserDueInMonthProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getUserGroupProductSum(params) { //分类获取企业分配给个人产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getUserGroupProductSum';
    return axios.post(url, qs.stringify(params));
  },
  
  getLoginInfor(params) { //获取天气、登录等信息
    const url =  baseURL + '/tbClientLog/getLoginInfor';
    return axios.post(url, qs.stringify(params));
  },
  
}



// WEBPACK FOOTER //
// ./src/api/manage.js